import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Chrome fires this when ResizeObserver callbacks affect layout in the same frame — benign in dev.
if (process.env.NODE_ENV === 'development') {
  const resizeObserverLoopRe = /^ResizeObserver loop/;
  window.addEventListener(
    'error',
    (event) => {
      if (resizeObserverLoopRe.test(event.message || '')) {
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
